module.exports = __webpack_public_path__ + "static/img/06012B_03_20170725_fit.bb68264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06012B_03_20170725_fit.png
// module id = Pxew
// module chunks = 0